var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 22,
    height: 22,
    fill: "#c06c84",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "price-tag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M2.292,0H8.106a4.1,4.1,0,0,1,2.918,1.208L21.218,11.4a2.671,2.671,0,0,1,0,3.777l-6.039,6.039a2.671,2.671,0,0,1-3.776,0l-10.2-10.2A4.1,4.1,0,0,1,0,8.106V2.292A2.294,2.294,0,0,1,2.292,0Zm2.75,7.333A2.292,2.292,0,1,0,2.75,5.042,2.294,2.294,0,0,0,5.042,7.333Z",
    fill: "#c06c84"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.fcf69f7cae48f1d7519cb853ef6a421d.svg";
export { ForwardRef as ReactComponent };